/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <!-- <img class="logoimg" src="../assets/img/logo.png" alt=""> -->
    </div>
    <div v-for="menu in allmenu" :key="menu.menuid" >
      <el-submenu v-if="menu.childMenusList.length !== 0" :index="menu.name">
        <template slot="title" ><span>{{menu.name}}</span></template>
        <div v-for="(chmenus , index ) in menu.childMenusList" :key="index">
          <el-submenu v-if="chmenus.childMenusList.length !== 0" :index="'/'+chmenus.uri" :key="chmenus.menuid">
            <template slot="title"><span>{{chmenus.name}}</span></template>
            <el-menu-item v-for="chmenus_li in chmenus.childMenusList" :index="'/'+chmenus_li.uri" :key="chmenus_li.menuid">{{chmenus_li.name}}</el-menu-item>
          </el-submenu>
          <el-menu-item v-if="chmenus.childMenusList.length == 0" :index="'/'+chmenus.uri" :key="chmenus.menuid">
            <span>{{chmenus.name}}</span>
          </el-menu-item>
          </div>
      </el-submenu>
      <el-menu-item v-if="menu.childMenusList.length == 0" :index="'/'+menu.uri" :key="menu.menuid">
        <span>{{menu.name}}</span>
      </el-menu-item>
    </div>
  </el-menu>
</template>
<script>
import { menu , loadMenuList } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'li-icon-xiangmuguanli',
          menuname: '用户管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: 'icon-cat-skuQuery',
              menuname: '注册用户列表',
              hasThird: 'N',
              url: 'userList/index',
              menus: null
            }
          ]
        },
        {
          menuid: 33,
          icon: 'li-icon-dingdanguanli',
          menuname: '广告位管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 34,
              icon: 'icon-order-manage',
              menuname: '小程序首页管理',
              hasThird: 'N',
              url: 'AppletBanner',
              menus: [
                {
                  menuid: 35,
                  icon: 'icon-cat-skuQuery',
                  menuname: '小程序banner管理',
                  hasThird: 'N',
                  url: 'AppletBanner/index',
                  menus: null
                }
              ]
            },
            {
              menuid: 34,
              icon: 'icon-order-manage',
              menuname: '麻将机首页管理',
              hasThird: 'N',
              url: 'pay/Order2',
              menus: [
                {
                  menuid: 35,
                  icon: 'icon-cat-skuQuery',
                  menuname: '设置主屏首页广告位管理',
                  hasThird: 'N',
                  url: 'pay/Order',
                  menus: null
                }
              ]
            },
            {
              menuid: 34,
              icon: 'icon-order-manage',
              menuname: '麻将机桌面管理',
              hasThird: 'N',
              url: 'pay/Order3',
              menus: [
                {
                  menuid: 35,
                  icon: 'icon-cat-skuQuery',
                  menuname: '主屏桌面广告管理',
                  hasThird: 'N',
                  url: 'pay/Order',
                  menus: null
                }
              ]
            }
          ]
        },
        {
          menuid: 71,
          icon: 'li-icon-xitongguanli',
          menuname: '系统管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 72,
              icon: 'icon-cus-manage',
              menuname: '员工管理',
              hasThird: 'N',
              url: 'system/user',
              menus: null
            },
            {
              menuid: 174,
              icon: 'icon-cms-manage',
              menuname: '菜单管理',
              hasThird: 'N',
              url: 'system/Module',
              menus: null
            },
            {
              menuid: 73,
              icon: 'icon-news-manage',
              menuname: '角色管理',
              hasThird: 'N',
              url: 'system/Role',
              menus: null
            },
          ]
        },
      ],
      data:'',
      msg: 'success'
    }
    loadMenuList().then(res=>{
      console.log(res.code)
      if(res.code == 401){
        this.$message({
            type: 'err',
            message: '登录失效'
        })
        this.$store.commit('logout', 'false')
        this.$router.push({ path: '/login' })
      }else {
        this.allmenu = res.menus
      }
      
    }).catch(err=>{
      console.log(err)
      if(err.code == 401){
        
      }
    })
    
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue